export default "__VITE_ASSET__m$hHXgFg__"